import React from 'react';
import { Link } from 'react-router-dom';
import SplashScreen from '../common/Splash/screen';
import projects from './projects.json';
import { FiExternalLink } from "react-icons/fi";

const Projects = () => {

    let dcProjects = [];
    const sweProjetcs = [];
    let dsProjects = [];

    const expandDiv = (event) => {
        let target = event.target
        let parent = target.parentElement
        console.log(parent)
        let more = parent.children[3]
        if (more.style.display === "none") {
            more.style.display = "block"
            target.innerHTML = "View Less"
        } else {
            more.style.display = "none"
            target.innerHTML = "View More"
        }
    }

    projects.map((prj) => {

        let rep;
        if (prj.subtype === "s") {
            rep = 
            <span className='project ds flex_column center'>
                <div className='name'>
                    <Link className='name' to={prj.link}>{prj.title} <FiExternalLink /></Link>
                </div>
                <div className='desc'>
                    {prj.insipiration}
                </div>
            </span>
        }
        else {
            rep =
            <div className='project'>
                <div className='name'>
                    <Link className='name' to={prj.link}>{prj.title} <FiExternalLink /></Link>
                </div>
                <div className='project_date'>
                    {prj.date}
                </div>
                <div className='desc'>
                    {prj.overview}
                </div>
                <div style={{display: "none"}}>
                    {prj.embed? <div className='embed center'>
                        <iframe src={prj.embed} title="SPTT" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        {prj.images.map((img) => {
                            return (
                                <span>
                                    <img src={process.env.PUBLIC_URL + img} alt="Project Image" />
                                </span>
                            )
                        })}
                    </div>: null}
                    <div className='center' style={{alignItems: "flex-start", justifyContent: "flex-start"}}>
                        <div className='prj_half'>
                            <div className='prj_half_title'>
                                The Inspiration
                            </div>
                            <div dangerouslySetInnerHTML={{__html: prj["insipiration"]}} />
                        </div>
                        <div className='prj_half'>
                            <div className='prj_half_title'>
                                The Challenge
                            </div>
                            <div dangerouslySetInnerHTML={{__html: prj["challenge"]}} />
                        </div>
                    </div>
                    <div className='prj_fts center flex_column'>
                        {prj.features.map((ft) => {
                            return <div>{ft}</div>
                        })}
                    </div>
                </div>
                <div className='read_more' onClick={expandDiv}>View More</div>
                <div className='skills'>
                    {prj.tech.map((skill) => {
                        return (
                            <span className='soft_skills'>
                                • {skill}
                            </span>
                        )
                    })}
                </div>
            </div>
        }
        if (prj.type === "cld") {
            dcProjects.push(rep);
        }
        if (prj.type === "swe") {
            sweProjetcs.push(rep);
        }
        if (prj.type === "ds") {            
            dsProjects.push(rep);
        }
    })

    return (
        <div id='projects'>
            <SplashScreen name="Projects" bgColor="white" color="#740A86" photo="/assets/credentials/all2.png" />
            <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start", backgroundColor:"#580068"}}>
                <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                    <div className='poster'>
                        Distributed Systems and Cloud Infrastructure
                        <div className='poster_hr'/>
                    </div>
                </div>
                <div className='project_list' id="Distributed Systems and Cloud Infrastructure" style={{flexWrap: "wrap"}}>
                    {[dcProjects]}
                </div>
            </div>
            <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", backgroundColor:"#31003C"}}>
                <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                    <div className='poster'>
                        Full-Stack Web Application and Software Engineering
                        <div className='poster_hr'/>
                    </div>
                </div>
                <div className='project_list' id="Full-Stack Web Application and Software Engineering" style={{flexWrap: "wrap"}}>
                    {[sweProjetcs]}
                </div>
            </div>
            <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start", backgroundColor:"#1B0021"}}>
                <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                    <div className='poster'>
                        Data Science and Machine Learning
                        <div className='poster_hr'/>
                    </div>
                </div>
                <div className='project_list center' id="Data Science and Machine Learning" style={{flexWrap: "wrap"}}>
                    {[dsProjects  ]}
                </div>
            </div>
        </div>
    )
}

export default Projects;